import BusinessTypes from "Containers/BusinessInformations/types"

export const setPrimaryActionColor = payload => ({
  type: BusinessTypes.SET_PRIMARY_ACTION_COLOR,
  payload,
})

export const setSecondaryColor = payload => ({
  type: BusinessTypes.SET_SECONDARY_COLOR,
  payload,
})

export const setBannerColor = payload => ({
  type: BusinessTypes.SET_BANNER_COLOR,
  payload,
})

export const setSeparatorColor = payload => ({
  type: BusinessTypes.SET_SEPARATOR_COLOR,
  payload,
})

export const getMyBusinessInformationsAction = () => ({
  type: BusinessTypes.GET_BUSINESS_INFORMATIONS,
})

export const getBusinessInformationsSuccessAction = payload => ({
  type: BusinessTypes.GET_BUSINESS_INFORMATIONS_SUCCESS,
  payload,
})

// Update Business information WITH notifications success
export const updateBusinessInformationsAction = payload => ({
  type: BusinessTypes.UPDATE_BUSINESS_INFORMATIONS,
  payload,
})

export const createBusinessRoleAction = payload => ({
  type: BusinessTypes.CREATE_BUSINESS_ROLE_OLD_VERSION,
  payload,
})

export const updateBusinessRoleAction = payload => ({
  type: BusinessTypes.UPDATE_BUSINESS_ROLE,
  payload,
})

export const deleteBusinessRoleAction = payload => ({
  type: BusinessTypes.DELETE_BUSINESS_ROLE,
  payload,
})

// Update Business information WITHOUT notifications success
export const updateBusinessWithoutNotsAction = payload => ({
  type: BusinessTypes.UPDATE_BUSINESS_WITHOUT_NOTIF,
  payload,
})

export const updateBusinessInformationsSuccessAction = payload => ({
  type: BusinessTypes.UPDATE_BUSINESS_INFORMATIONS_SUCCESS,
  payload,
})

// Get users by business
export const getBusinessUsersAction = payload => ({
  type: BusinessTypes.GET_BUSINESS_USERS,
  payload,
})

export const getBusinessUsersSuccessAction = payload => ({
  type: BusinessTypes.GET_BUSINESS_USERS_SUCCESS,
  payload,
})

// Update users
export const updateBusinessUsersAction = payload => ({
  type: BusinessTypes.UPDATE_BUSINESS_USERS,
  payload,
})

// Delete users
export const deleteBusinessUsersAction = payload => ({
  type: BusinessTypes.DELETE_USER,
  payload,
})

// Create users
export const createBusinessUsersAction = payload => ({
  type: BusinessTypes.CREATE_USER,
  payload,
})

export const getBusinessLogoAction = payload => ({
  type: BusinessTypes.GET_BUSINESS_LOGO,
  payload,
})
export const getBusinessLogoSuccess = payload => ({
  type: BusinessTypes.GET_BUSINESS_LOGO_SUCCESS,
  payload,
})

export const uploadBusinessLogoAction = payload => ({
  type: BusinessTypes.UPLOAD_BUSINESS_LOGO,
  payload,
})
export const uploadBusinessLogoSuccess = payload => ({
  type: BusinessTypes.UPLOAD_BUSINESS_LOGO_SUCCESS,
  payload,
})

export const resetCheckedEmailAction = () => ({
  type: BusinessTypes.RESET_CHECKED_EMAIL,
})
export const setEmailCheckedAction = payload => ({
  type: BusinessTypes.SET_CHECKED_EMAIL,
  payload,
})
export const getAlreadyUsedEmailAction = payload => ({
  type: BusinessTypes.GET_ALREADY_USED_EMAIL,
  payload,
})
export const getAlreadyUsedEmailSuccess = payload => ({
  type: BusinessTypes.GET_ALREADY_USED_EMAIL_SUCCESS,
  payload,
})

// Update businessDefaultPaletteId
export const updateBusinessDefaultPaletteAction = payload => ({
  type: BusinessTypes.UPDATE_BUSINESS_DEFAULT_PALETTE,
  payload,
})

// Set NavBar Business
export const setNavBarBusinessAction = payload => ({
  type: BusinessTypes.SET_LINK_NAVBAR_BUSINESS,
  payload,
})

export const resetNavBarBusinessAction = payload => ({
  type: BusinessTypes.RESET_LINK_NAVBAR_BUSINESS,
  payload,
})

//******************************** ROLES ***************************************
export const getRolesAction = payload => ({
  type: BusinessTypes.GET_ROLES,
  payload,
})

export const getRolesSuccess = payload => ({
  type: BusinessTypes.GET_ROLES_SUCCESS,
  payload,
})

export const getRolesOfUserSuccess = payload => ({
  type: BusinessTypes.GET_ROLES_OF_USER_SUCCESS,
  payload,
})

export const createRoleAction = payload => ({
  type: BusinessTypes.CREATE_ROLE,
  payload,
})

export const createRoleSuccess = payload => ({
  type: BusinessTypes.CREATE_ROLE_SUCCESS,
  payload,
})

export const updateRoleAction = payload => ({
  type: BusinessTypes.UPDATE_ROLE,
  payload,
})

export const updateRoleSuccess = payload => ({
  type: BusinessTypes.UPDATE_ROLE_SUCCESS,
  payload,
})

export const deleteRoleAction = payload => ({
  type: BusinessTypes.DELETE_ROLE,
  payload,
})

export const deleteRoleSuccess = payload => ({
  type: BusinessTypes.DELETE_ROLE_SUCCESS,
  payload,
})

//******************************** GROUP ***************************************
export const getBusinessGroupAction = payload => ({
  type: BusinessTypes.GET_BUSINESS_GROUP,
  payload,
})

export const getBusinessGroupSuccessAction = payload => ({
  type: BusinessTypes.GET_BUSINESS_GROUP_SUCCESS,
  payload,
})

export const getBusinessGroupByIdAction = payload => ({
  type: BusinessTypes.GET_BUSINESS_GROUP_BY_ID,
  payload,
})

export const getBusinessGroupByIdSuccessAction = payload => ({
  type: BusinessTypes.GET_BUSINESS_GROUP_BY_ID_SUCCESS,
  payload,
})

export const getMyGroupsAction = payload => ({
  type: BusinessTypes.GET_MY_GROUPS,
  payload,
})

export const getMyGroupsSucessAction = payload => ({
  type: BusinessTypes.GET_MY_GROUPS_SUCCESS,
  payload,
})

export const postBusinessGroupAction = payload => ({
  type: BusinessTypes.CREATE_GROUP,
  payload,
})

export const postBusinessGroupSuccessAction = payload => ({
  type: BusinessTypes.POST_BUSINESS_GROUP_SUCCESS,
  payload,
})

export const patchGroupAction = payload => ({
  type: BusinessTypes.PATCH_GROUP,
  payload,
})

export const patchGroupSuccessAction = payload => ({
  type: BusinessTypes.PATCH_GROUP_SUCCESS,
  payload,
})

export const deleteGroupAction = payload => ({
  type: BusinessTypes.DELETE_OR_ARCHIVE_GROUP,
  payload,
})

export const deleteBusinessGroupSuccessAction = payload => ({
  type: BusinessTypes.DELETE_BUSINESS_GROUP_SUCCESS,
  payload,
})

export const addUserBusinessGroupAction = payload => ({
  type: BusinessTypes.ADD_USER_BUSINESS_GROUP,
  payload,
})

export const addUserBusinessGroupSuccessAction = payload => ({
  type: BusinessTypes.ADD_USER_BUSINESS_GROUP_SUCCESS,
  payload,
})

export const deleteUserAllGroupAction = payload => ({
  type: BusinessTypes.DELETE_USER_ALL_GROUP,
  payload,
})

export const deleteUserAllGroupSuccessAction = payload => ({
  type: BusinessTypes.DELETE_USER_ALL_GROUP_SUCCESS,
  payload,
})

export const changeUserInGroupAction = payload => ({
  type: BusinessTypes.CHANGE_USER_IN_GROUP,
  payload,
})

export const changeUserInGroupSuccessAction = payload => ({
  type: BusinessTypes.CHANGE_USER_IN_GROUP_SUCCESS,
  payload,
})

export const updateClientLogoAction = payload => ({
  type: BusinessTypes.UPDATE_CLIENT_LOGO,
  payload,
})

export const deleteClientLogoAction = payload => ({
  type: BusinessTypes.DELETE_CLIENT_LOGO,
  payload,
})

